import { memo, ReactNode } from 'react';
import classes from 'classnames';
import CloseIcon from '@/assets/icons/close.svg?react';
import ErrorIcon from '@/assets/icons/error.svg?react';
import SuccessIcon from '@/assets/icons/success.svg?react';
import styles from './Notification.module.scss';

export type Props = {
  children: ReactNode;
  onClose?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  dataTest?: string;
  type?: 'success' | 'error';
  className?: string;
  contentClassName?: string;
  iconClassName?: string;
};

const NotificationMemo = memo(function Notification({
  children,
  onClose,
  dataTest = 'notification',
  type = 'success',
  className,
  contentClassName,
  iconClassName,
}: Props) {
  return (
    <div
      className={classes(styles.container, styles[type], className)}
      data-test={dataTest}
    >
      <div className={classes(styles.content, contentClassName)}>
        <div className={classes(styles['type-icon'], iconClassName)}>
          {type === 'error' && (
            <ErrorIcon data-test={`${dataTest}-error-icon`} />
          )}
          {type === 'success' && (
            <SuccessIcon data-test={`${dataTest}-success-icon`} />
          )}
        </div>
        {children}
      </div>
      {onClose && (
        <button
          type="button"
          className={styles.close}
          onClick={onClose}
          data-test={`${dataTest}-btn`}
          aria-label="close-btn"
        >
          <CloseIcon
            className={styles.icon}
            data-test={`${dataTest}-close-icon`}
          />
        </button>
      )}
    </div>
  );
});

export default NotificationMemo;
